import React, {useState} from 'react';
import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';
import {makeStyles} from "@material-ui/core/styles";
import StarBorderIcon from '@material-ui/icons/StarBorder';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    icon: {
        color: 'rgb(176, 176, 176)',
    }
}));

const RatingCard = (props) => {
    const classes = useStyles();
    const [value, setValue] = useState(3);
    return(
        <div>
            <Box component="fieldset" mb={3} borderColor="transparent" className={classes.root}>
                <Rating
                    name="radio-rating"
                    value={value}
                    // precision={0.5}
                    emptyIcon={<StarBorderIcon fontSize="inherit" className={classes.icon} />}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                />
            </Box>
        </div>
    );
};

export default RatingCard;